import React from "react";
import Header from "../../component/Header";
import Background from "../../assets/Images/homepage.png";
import SearchBox from "../../component/home/SearchBox";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "sonner";

// ------------images collection---------------

const Hero = () => {
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.user);
  const handleCv = () => {
    if (loggedInUser?.currentUser === null) {
      toast.error("Kindly login to continue");
      navigate("/signin");
      return;
    }
    if (loggedInUser?.currentUser?.userType !== "jobSeeker") {
      toast.info("Only for jobSeekers");
      return;
    }
    navigate(`/${loggedInUser?.currentUser?._id}/createCV`);
  };

  const handleBenefit = () => {
    if (loggedInUser?.currentUser === null) {
      toast.error("Kindly login to continue");
      navigate("/signin");
      return;
    }
    if (loggedInUser?.currentUser?.userType !== "jobSeeker") {
      toast.info("Only for jobSeekers");
      return;
    }
    navigate(`/benefit`);
  };
  return (
    <div>
      <section
        style={{
          background: `url(${Background}) no-repeat center center/cover`,
        }}
        className="text-sm pt-16 sm:pt-20"
      >
        <div className="mb-10">
          <Header lightMode={true} />
        </div>

        <div className="absolute top-15 right-10 flex gap-4 mb-4 sm:mb-20">
          <button
            onClick={handleBenefit}
            className="bg-orange-500 px-6 py-2 rounded-full text-white hover:bg-orange-600 transition-colors"
          >
            Apply for allowance
          </button>
          <button
            onClick={handleCv}
            className="bg-orange-500 px-6 py-2 rounded-full text-white hover:bg-orange-600 transition-colors"
          >
            Create a free CV
          </button>
        </div>

        {/* search section */}
        <SearchBox />
      </section>
    </div>
  );
};

export default Hero;
